export default __webpack_public_path__ + "static/media/kycArt.074e6551.png";